import React, { useState, useEffect } from "react";
// Chakra imports
import {
  Flex,
  Progress,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import IconBox from "components/Icons/IconBox";
// Custom icons
import { WalletIcon } from "components/Icons/Icons.js";
import useGetOrderTotal from "hooks/useGetOrderTotal";



function DashboardTotal({
    type,
}) { 

    const { colorMode, toggleColorMode } = useColorMode();
    const iconTeal = useColorModeValue("teal.300", "teal.300");
    const iconBoxInside = useColorModeValue("white", "white");
    const textColor = useColorModeValue("gray.700", "white");

    let label;
    switch(type) {
        case 'Year':
            label = `YTD`;
            break;
        case 'Month':
            label = `This Month`;
            break;
        case 'Week':
            label = `This Week`;
            break;
        case 'Day':
        default:
            label = `Today's`;
            break;
    }


    let { 
        orderTotal, 
        gettingOrderTotal, 
        setGettingOrderTotal, 
        gettingOrderTotalReqSuccess
    } = useGetOrderTotal({
        type: type,
    });

    useEffect(() => {
        setGettingOrderTotal(true);
    }, []);

    
    return (
        <Card minH="83px">
            <CardBody>
            <Flex flexDirection="row" align="center" justify="center" w="100%">
                <Stat me="auto">
                <StatLabel
                    fontSize="sm"
                    color="gray.400"
                    fontWeight="bold"
                    pb=".1rem"
                >
                    {label} Sales
                </StatLabel>
                <Flex>
                    {gettingOrderTotal
                        ? <Progress isIndeterminate />
                        : <StatNumber fontSize="lg" color={textColor}>
                            ₱{Number(orderTotal).toLocaleString()}
                        </StatNumber>
                    }
                </Flex>
                </Stat>
                <IconBox as="box" h={"45px"} w={"45px"} bg={iconTeal}>
                <WalletIcon h={"24px"} w={"24px"} color={iconBoxInside} />
                </IconBox>
            </Flex>
            </CardBody>
        </Card>
    );
}


export default DashboardTotal;
